import React, { useContext } from 'react';
import UserContext from '../../context/UserContext.js';
import BotonEliminar from '../UI/botones/BotonEliminar.js';
import BotonEdicion from '../UI/botones/BotonEdicion.js';
import * as ModoEdicion from '../constantes/ModoEdicion.js';
import styles from './CuadroListaEditable.module.css';

const ColumnaBotoneraItem = (props) => {
  const idItem = props.idItem;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;
  const className = props.className || styles.botonera;
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;

  return (
    <React.Fragment>
      {puedeEditar && (
        <td className={className}>
          <BotonEdicion id={idItem} modo={ModoEdicion.EDITAR} onClick={onEditarItem} />
          <BotonEliminar id={idItem} onClick={onEliminarItem} />
        </td>
      )}
    </React.Fragment>
  );
};

export default ColumnaBotoneraItem;
